/**
 * Component that gates content behind a subscription plan requirement.
 * Similar to RequireCapability but for plan tiers instead of roles.
 */

import type { ReactNode } from 'react';
import type { PlanFeature, PlanTier } from '@tilly/shared';
import { useEntitlements } from './useEntitlements';
import { UpgradePrompt } from '@/components/UpgradePrompt';

interface RequirePlanProps {
  feature: PlanFeature;
  children: ReactNode;
  fallback?: ReactNode;
  requiredTier?: PlanTier;
}

export function RequirePlan({ feature, children, fallback, requiredTier }: RequirePlanProps) {
  const { hasFeature } = useEntitlements();

  if (!hasFeature(feature)) {
    return <>{fallback || <UpgradePrompt feature={feature} requiredTier={requiredTier} />}</>;
  }

  return <>{children}</>;
}
